export enum TYPE_PROFILES {
  PRODUCER_AGENCY = 'PRODUCER_AGENCY',
  ASSISTANT_DIRECTOR = 'ASSISTANT_DIRECTOR',
  GLOBO_PRODUCER = 'GLOBO_PRODUCER',
  PRODUCTION_BASE = 'PRODUCTION_BASE',
}
